import "./GaleryBlock.css";
import MiddleBlock from "../../../../components/MiddleBlock/MiddleBlock";
import { useEffect, useState } from "react";
import { loadFullGallery } from "../../../../api/api";
import Lightbox from "../../../../components/elements/Lightbox/Lightbox";
import { NavLink } from "react-router-dom";
import Loader from "../../../../components/elements/Loader/Loader";
import EmptyState from "../../../../components/elements/EmptyState/EmptyState";

export default function GaleryBlock() {
    const [galleryImages, setGalleryImages] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        async function loadGallery() {
            try {
                const response = await loadFullGallery(6);
                
                if (response.success && response.data) {
                    const images = response.data.map(img => ({
                        id: img.id,
                        path: img.image_path,
                        caption: img.caption || '',
                        sort_order: img.sort_order || 0,
                    }));
                    
                    setGalleryImages(images);
                } else {
                    setGalleryImages([]);
                }
            } catch (error) {
                console.error('Nie udało się wczytać galerii:', error);
                setGalleryImages([]);
            } finally {
                setLoading(false);
            }
        }
        
        loadGallery();
    }, []);

    if (loading) return <Loader />;

    if (!galleryImages || galleryImages.length === 0) return (
        <MiddleBlock>
            <EmptyState type="gallery" title="Galeria czeka na pierwsze wspomnienia">
                Zdjęcia z naszych wydarzeń pojawią się tutaj, gdy tylko je dodamy.
            </EmptyState>
        </MiddleBlock>
    );

    return (
        <MiddleBlock>
            <div className="galery-container">
                <Lightbox>
                    {galleryImages.map((image) => (
                        <img 
                            key={image.id || Math.random()} 
                            src={image.path} 
                            alt={image.caption || 'Zdjęcie galerii'} 
                            className="photo-block-img"
                        />
                    ))}
                </Lightbox>
                
                <div className="galery-footer">
                    <NavLink to={"show-gallery"}>
                        <button 
                            className="galery-open-btn"
                        >
                            Zobacz galerię →
                        </button>
                    </NavLink>
                </div>
            </div>
        </MiddleBlock>
    );
}
